import React, { useState, useEffect } from 'react';
import CloseDialogIcon from '../../../../assets/image/Mask.png';
import DefaultButton from "../../../Buttons/DefaultButton/DefaultButton";
import IconButton from '@material-ui/core/IconButton';
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import { splitRefundRequest } from "../../../../actions/refundRequestsActions";
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import '../RefundRequestsHeaderButtonsPanel.scss';

const SplitRefundDialogContent = ({ onClose, onSuccess, selectedRow = {}, splitRefundRequest, onError }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [disabledBtn, setDisabledBtn] = useState(true);
    const [products, setProducts] = useState([]);

    useEffect(() => {
        if (selectedRow.productInfo) {
            setProducts(
                selectedRow.productInfo.map(product => ({
                    ...product,
                    amountLeft: product.amount,
                    amountRight: 0,
                }))
            );
        }
    }, [selectedRow]);

    useEffect(() => {
        const totalLeft = products.reduce((sum, p) => sum + p.amountLeft, 0);
        const totalRight = products.reduce((sum, p) => sum + p.amountRight, 0);
        setDisabledBtn(totalLeft === 0 || totalRight === 0);
    }, [products]);

    const handleAmountChange = (related_id, direction) => {
        setProducts(prev => prev.map(product => {
            if (product.related_id !== related_id) return product;
            if (direction === 'toRight' && product.amountLeft > 0) {
                return {
                    ...product,
                    amountLeft: product.amountLeft - 1,
                    amountRight: product.amountRight + 1
                };
            }
            if (direction === 'toLeft' && product.amountRight > 0) {
                return {
                    ...product,
                    amountLeft: product.amountLeft + 1,
                    amountRight: product.amountRight - 1
                };
            }
            return product;
        }));
    };

    const handleMoveAll = (related_id, direction) => {
        setProducts(prev => prev.map(product => {
            if (product.related_id !== related_id) return product;
            if (direction === 'toRight' && product.amountLeft > 0) {
                return {
                    ...product,
                    amountLeft: 0,
                    amountRight: product.amountRight + product.amountLeft
                };
            }
            if (direction === 'toLeft' && product.amountRight > 0) {
                return {
                    ...product,
                    amountLeft: product.amountLeft + product.amountRight,
                    amountRight: 0
                };
            }
            return product;
        }));
    };

    const renderList = (title, type) => (
        <Paper style={{ width: 500, height: 400, overflow: 'auto' }}>
            <Typography variant="h6" style={{ padding: '16px' }}>{title}</Typography>
            <List dense component="div" role="list">
                {products.filter(p => (type === 'left' ? p.amountLeft > 0 : p.amountRight > 0)).map(product => (
                    <ListItem key={product.related_id} role="listitem" style={{ paddingRight: 120 }}>
                        <ListItemText
                            primary={`Заказ ${product.ordernum} (${product.user}) - ${type === 'left' ? product.amountLeft : product.amountRight}шт`}
                            secondary={`${product.name} (${product.article_number})`}
                            style={{ marginRight: 120 }}
                        />
                        <ListItemSecondaryAction style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                            {type === 'left' ? (
                                <>
                                    <IconButton size="small" onClick={() => handleMoveAll(product.related_id, 'toLeft')} disabled={product.amountRight === 0} title="Перенести все влево">
                                        <ChevronLeftIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" onClick={() => handleAmountChange(product.related_id, 'toLeft')} disabled={product.amountRight === 0} title="Перенести 1 влево">
                                        <RemoveIcon fontSize="small" />
                                    </IconButton>
                                    <span style={{ minWidth: 20, textAlign: 'center' }}>{product.amountLeft}</span>
                                    <IconButton size="small" onClick={() => handleAmountChange(product.related_id, 'toRight')} disabled={product.amountLeft === 0} title="Перенести 1 вправо">
                                        <AddIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" onClick={() => handleMoveAll(product.related_id, 'toRight')} disabled={product.amountLeft === 0} title="Перенести все вправо">
                                        <ChevronRightIcon fontSize="small" />
                                    </IconButton>
                                </>
                            ) : (
                                <>
                                    <IconButton size="small" onClick={() => handleMoveAll(product.related_id, 'toLeft')} disabled={product.amountRight === 0} title="Перенести все влево">
                                        <ChevronLeftIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" onClick={() => handleAmountChange(product.related_id, 'toLeft')} disabled={product.amountRight === 0} title="Перенести 1 влево">
                                        <RemoveIcon fontSize="small" />
                                    </IconButton>
                                    <span style={{ minWidth: 20, textAlign: 'center' }}>{product.amountRight}</span>
                                    <IconButton size="small" onClick={() => handleAmountChange(product.related_id, 'toRight')} disabled={product.amountLeft === 0} title="Перенести 1 вправо">
                                        <AddIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton size="small" onClick={() => handleMoveAll(product.related_id, 'toRight')} disabled={product.amountLeft === 0} title="Перенести все вправо">
                                        <ChevronRightIcon fontSize="small" />
                                    </IconButton>
                                </>
                            )}
                        </ListItemSecondaryAction>
                    </ListItem>
                ))}
            </List>
        </Paper>
    );

    const handleSplit = async () => {
        setLoadingBtn(true);
        const right = products.filter(p => p.amountRight > 0).map(p => ({ related_id: p.related_id, amount: p.amountRight }));
        const res = await splitRefundRequest(selectedRow.id, right);
        setLoadingBtn(false);
        if (res && res.error) {
            const message =
                (res.error.response &&
                    res.error.response.data &&
                    res.error.response.data.error &&
                    res.error.response.data.error[0]) ||
                'Произошла ошибка. Повторите попытку позже.';
            onError(message);
            return;
        }
        onSuccess();
    };

    return (
        <div>
            <div className="title-dialog">
            
                Разделить заявку №{selectedRow.documentNumber ? selectedRow.documentNumber : selectedRow.orderNum}
            </div>
            <div className="dialog-form-wrapper transfer-list-container">
                <Grid container alignItems="center" justifyContent="center" spacing={2}>
                    <Grid item>{renderList('Первая заявка', 'left')}</Grid>
                    <Grid item>{renderList('Вторая заявка', 'right')}</Grid>
                </Grid>
            </div>
            <div className="btn-wrapper order-dialog-btn">
                <DefaultButton
                    variant="outlined"
                    classes="cancel_btn"
                    onClick={onClose}
                >
                    Отмена
                </DefaultButton>
                <DefaultButton
                    loading={loadingBtn}
                    disabled={loadingBtn || disabledBtn}
                    onClick={handleSplit}
                >
                    Разделить
                </DefaultButton>
            </div>
            <IconButton
                classes={{
                    root: "dialog_close_button"
                }}
                onClick={onClose}
            >
                <img src={CloseDialogIcon} alt="close icon" />
            </IconButton>
        </div>
    );
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        splitRefundRequest,
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(SplitRefundDialogContent);
